// Chess game block schema - Interactive chess game for "Play Me" feature
export const chessGameSchema = {
  type: 'chess-game',
  label: 'Chess Game',
  description: 'Interactive chess game - play against visitors',
  icon: 'Swords',
  defaultContent: {
    enabled: true,
    title: 'Play Chess With Me',
    ownerColor: 'white',
    matchThemeSquares: false,
    style: {},
  },
  fields: [
    { name: 'title', label: 'Section Title', type: 'text' },
    {
      name: 'ownerColor',
      label: 'Your Color',
      type: 'select',
      options: [
        { value: 'white', label: 'White' },
        { value: 'black', label: 'Black' }
      ]
    },
    { name: 'matchThemeSquares', label: 'Match Theme Color', type: 'checkbox' },
  ],
};
